import Hero from "@modules/about/hero";
import Journey from "@modules/about/journey";
import Team from "@modules/about/team";
import VisionAndMission from "@modules/about/vision-and-mission";
import Head from "@modules/common/components/head";
import { AboutPage } from "types/about";

export default function index({ aboutPage }: { aboutPage: AboutPage }) {
  return (
    <div className="font-myFont">
      <Head />
      <Hero />
      <div className="bg-darkGreen min-h-screen md:px-20 px-8 relative z-10">
        <VisionAndMission
          vision={aboutPage.vision}
          mission={aboutPage.mission}
        />

        <Team teamImage={aboutPage.teamImage} />
        <Journey journey={aboutPage.journey} />
      </div>
    </div>
  );
}

export async function getStaticProps() {
  const strapiUrl = process.env.NEXT_PUBLIC_STRAPI_URL;
  const headers = {
    Authorization: `Bearer ${process.env.NEXT_PUBLIC_STRAPI_TOKEN}`,
  };

  let aboutPage = {};

  try {
    // Fetch restaurants da
    const aboutPageApi = await fetch(
      `${strapiUrl}/api/about?populate=journey.stepImage&populate=teamImage`,
      {
        headers,
      }
    );

    if (aboutPageApi.ok) {
      const aboutData = await aboutPageApi.json();
      aboutPage = aboutData.data || {};
    }
  } catch (error) {
    console.error(`Error fetching data from Strapi: ${error}`);
  }

  console.log("aboutPage", aboutPage);

  return {
    props: {
      aboutPage: aboutPage,
    },
    revalidate: 10, // Revalidate every 10 seconds for fresh data
  };
}
